import YVideos from './YourVideos';

export const YourVideos = YVideos;
